/* ==================================
=            Middlewares           =
================================== */
import { checkAcceptTerms } from './terms/index';
import _ from 'underscore';
// import Utils from '../utils/Utils';
// import { metrics } from './metrics/index'; Not use for now, could be use on init App

const _middlewares = [
  checkAcceptTerms,
];

const exec = (next, action) => {
  _middlewares.map(middleware => {
    middleware(() => {
      return middleware;
    });
  });
  next(action);
};

export const middlewares = store => next => action => {
  // if (action.type == 'checkLogin' && _.isObject(store.getState().config)) {
  //   const config = store.getState().config;
  //   const nextAction = action;
  //   nextAction.checkLogin = true;

  //   Utils.checkLogin({ config }, () => {
  //     return next(action);
  //   });
  // }
  
  // Discard subsequent actions
  if (action.type == 'middleware') {
    exec(next, action);
  } else {
    // Use obligatories middlewares
    checkAcceptTerms(() => {
      return next(action);
    });
  }
};
